import React from 'react'
import { styled } from 'styled-components'
import Navbar from '../components/Navbar'
import HeroSection from '../components/HeroSection'
import LeadershipIntro from '../components/leadership/LeadershipIntro'
import FooterSection from '../components/FooterSection'

const Leadership = () => {
  return (
    <Wraper>
        <Navbar />
        <HeroSection title="Professor Benjamin Agyei-Tuffour." tagline="Chief Patron, African Materials Research Society (AMRS) GHANA" />
        <LeadershipIntro />
        <FooterSection />
    </Wraper>
  )
}

const Wraper = styled.div``;

export default Leadership